import React, { createContext, useContext } from 'react';
import { useFetchBetBuilderEvents } from '../../data/useFetchBetBuilderEvents';
import Loader from '../../common/Loader';

export const BetBuilderEventsContext = createContext(null);

export function useBetBuilderEvents() {
    return useContext(BetBuilderEventsContext);
}

export default function BetBuilderEventsProvider(props) {
    const [request] = useFetchBetBuilderEvents(props.data, props.tournament, true, false);

    if (request.isLoading || request.isError) {
        return (
            <>
                <Loader error={request.isError} />
            </>
        );
    }

    return (
        <BetBuilderEventsContext.Provider value={request.data}>
            {props.children}
        </BetBuilderEventsContext.Provider>
    );
}
